import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchTerm: "",
  featured: "All",
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    search: (state, action) => {
      state.searchTerm = action.payload;
    },
    type: (state, action) => {
      state.featured = action.payload;
    },
  },
});

export const { search, type } = filterSlice.actions;
export default filterSlice.reducer;
